import Vue from "vue";
import VueResource from "vue-resource";
import BootstrapVue from "bootstrap-vue";
import VueClipboard from "vue-clipboard2";

import { router } from "./routes.js";
import { store } from "./store/index.js";

import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "vue-awesome/icons/ruble-sign";
import "vue-awesome/icons/caret-square-right";
import "vue-awesome/icons/caret-square-left";
import Icon from "vue-awesome/components/Icon";

import MaskedInput from "vue-masked-input";

Vue.component("masked-input", MaskedInput);

Vue.component("v-icon", Icon);

Vue.use(VueResource);
Vue.use(store);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
//Vue.http.options.root = process.env.NODE_ENV === "development" ? "http://localhost:80/data/" : 'http://ligasound.ru/data/'
Vue.http.options.root =
    process.env.NODE_ENV === "development" ?
    "http://localhost:80/data_ls/" :
    "./data/";

Vue.use(BootstrapVue);

Vue.directive("scroll", {
    inserted: function(el, binding) {
        let f = function(evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener("scroll", f);
            }
        };
        window.addEventListener("scroll", f);
    },
});

new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
});